<template>
    <LayoutSub className="product_detail">
        <SubSection>
            <section class="swiper_section">
                <div class="left_area">
                    <div class="swiper mySwiper">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" :class="{ 'no-image': thumbError }">
                                <img
                                    :src="data.thumbPath || defaultImagePath"
                                    :alt="data.orgThumbname || 'Thumbnail'"
                                    @load="handleImageLoad($event, 'thumb')"
                                    @error="handleImageError($event, 'thumb')"
                                />
                            </div>
                            <div 
                                class="swiper-slide" 
                                v-for="(filePath, index) in data.filePaths" 
                                :key="'swiper-' + index"
                                :class="{ 'no-image': imageErrors[index] }"
                            >
                                <img
                                    :src="filePath || defaultImagePath"
                                    :alt="data.orgFilenames[index] || 'Image ' + (index + 1)"
                                    @load="handleImageLoad($event, index)"
                                    @error="handleImageError($event, index)"
                                />
                            </div>
                        </div>
                        <div class="swiper-handle">
                            <div class="swiper-button-prev">
                                <img src="@/assets/swiper_left.png" alt="" />
                            </div>
                            <div class="swiper-button-next">
                                <img src="@/assets/swiper_right.png" alt="" />
                            </div>
                        </div>
                    </div>
                    <div class="thumbnail_wrapper ">
                        <a class="item" :href="data.link" target="_blank" v-if="data.link" style="background: var(--orange);">
                            <img src="@/assets/ic_outerbuy.png" alt="" style="width: 50%;"/>
                        </a>
                        <div 
                            class="item" 
                            :class="{ active: activeIndex === 0 }" 
                            @click="onThumbnailClick(0)"
                        >
                            <img :src="data.thumbPath || defaultImagePath" :alt="data.orgThumbname || 'Thumbnail'" @error="setDefaultImage"/>
                        </div>
                        <div 
                            v-for="(filePath, index) in data.filePaths" 
                            :key="'thumbnail-' + index" 
                            class="item" 
                            :class="{ active: activeIndex === index + 1 }" 
                            @click="onThumbnailClick(index + 1)"
                        >
                            <img :src="filePath || defaultImagePath" :alt="data.orgFilenames[index] || 'Thumbnail ' + (index + 1)" @error="setDefaultImage"/>
                        </div>
                    </div>
                </div>
                <div class="right_area">
                    <p class="infor_top">{{ data.title }}</p>
                    <p class="infor_name">{{ data.productName }}</p>
                    <p class="infor_desc">
                        {{ data.productDescription }}
                    </p>
                    <ul>
                        <li v-for="(item, idx) of data.productFeatures" :key="idx">{{ item }}</li>
                    </ul>
                    <div class="button_wrap">
                        <RedLineButton v-if="data.manualPath" type="download" text="메뉴얼 다운로드" :link="data.manualPath"
                            :filename="data.manualOrgFilename"></RedLineButton>
                        <RedLineButton v-if="data.leafletPath" type="download" text="리플릿 다운로드" :link="data.leafletPath"
                            :filename="data.leafletOrgFilename"></RedLineButton>
                    </div>
                </div>
            </section>
        </SubSection>
        <SubSection type="wide">
            <section class="content product_content mt-0">
                <SubTitle3 listStyle="dot">특징</SubTitle3>
                <div v-html="data.contents"></div>
                <!-- <div class="row">
                    <div class="prd_module">
                        <div class="img_box">
                            <img src="@/assets/pos_dummy/prd_detail01.png" alt="" />
                        </div>
                        <h3>KICC 고성능 안드로이드 포스</h3>
                        <ul>
                            <li>10.1인치 대형화면</li>
                            <li>2GB FAM / 16GB 저장공간 탑재</li>
                            <li>양방향 IC 리더기 (삼성페이가능)</li>
                            <li>Quard Core CPU 탑재 (Cortex-A55)</li>
                        </ul>
                    </div>
                    <div class="prd_module">
                        <div class="img_box">
                            <img src="@/assets/pos_dummy/prd_detail02.png" alt="" />
                        </div>
                        <h3>동시 사용에 최적화된 디스플레이 설계</h3>
                        <p>화면을 앞, 뒤로 회전할 수 있어 포스와 키오스크를 동시에 사용할 수 있습니다.</p>
                    </div>
                </div>
                <div class="row">
                    <div class="prd_module">
                        <div class="img_box">
                            <img src="@/assets/pos_dummy/prd_detail03.png" alt="" />
                        </div>
                        <h3>업그레이드 된 포스/키오스크 모드 전환</h3>
                        <p>
                            모션감지 센서가 있어 화면만 돌려도모드를 변경할 수 있는 기능이 추가되었습니다.<br />
                            화면 버튼을 선택해서,혹은 환경설정을 통해서 변경도 가능합니다.
                        </p>
                    </div>
                    <div class="prd_module">
                        <div class="img_box">
                            <img src="@/assets/pos_dummy/prd_detail04.png" alt="" />
                        </div>
                        <h3>양방향 리더기 장착 및 카드결제 지원</h3>
                        <p>POS 장비 최초로 좌우 리더기를 장착해 결제 시 모두 사용할 수 있습니다.<br />IC / MSR 결제 둘 다 지원합니다.</p>
                    </div>
                </div>
                <div class="row">
                    <div class="prd_module">
                        <div class="img_box">
                            <img src="@/assets/pos_dummy/prd_detail05.png" alt="" />
                        </div>
                        <h3>모든 결제수단 지원</h3>
                        <p>화면 사이드에 카메라가 있어서 바도크 리딩 및 간편결제가 가능합니다.</p>
                    </div>
                    <div class="prd_module">
                        <div class="img_box">
                            <img src="@/assets/pos_dummy/prd_detail06.png" alt="" />
                        </div>
                        <h3>오토커팅 프린터 탑재</h3>
                        <p>
                            3인치 오토커팅 프린터가 내장되어 있습니다.<br />
                            장비 하단에 버튼만 누르면 용지를 쉽게 교체할 수 있습니다.
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="prd_module">
                        <div class="img_box">
                            <img src="@/assets/pos_dummy/prd_detail07.png" alt="" />
                        </div>
                        <h3>안정적인 외형 설계와 충분한 포트 구성</h3>
                        <p>장비 측면에 있는 포트로 다양한 장비 연결이 가능합니다.</p>
                        <ul class="type2">
                            <li>
                                <p>HDMI를 통한 듀얼 모드 사용 가능</p>
                                <p>외부 터치 모니터와 연결하여 듀얼로 사용해 오더포스와 결제포스로 사용 가능합니다.</p>
                            </li>
                            <li>
                                <p>Ethemet Port</p>
                                <p>LAN을 통해 인터넷 통신 환경을 이용하여 빠른 속도로 결제를 처리할 수 있습니다.</p>
                            </li>
                            <li>
                                <p>Serial Port</p>
                                <p>RJ114P4C커넥터를 통해 다양한 KICC 호환기기 연결이 가능합니다.</p>
                            </li>
                            <li>
                                <p>USB</p>
                                <p>USB Port를 통해 주변기기 확장이 가능합니다. (EX. 키보드, 마우스 등)</p>
                            </li>
                            <li>
                                <p>금전통</p>
                                <p>6pin 포트를 통해 돈통 연결이 가능합니다.</p>
                            </li>
                        </ul>
                    </div>
                </div> -->
            </section>
        </SubSection>
        <SubSection class="pb-0">
            <section class="table">
                <SubTitle3 listStyle="dot">제품사양</SubTitle3>
                <div v-for="(spec, index) in data.specList" :key="index">
                    <table>
                        <thead>
                            <tr>
                                <th colspan="2">{{ spec.tableTitle }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(detail, detailIndex) in spec.specDetailList" :key="detailIndex">
                                <th>{{ detail.title }}</th>
                                <td v-html="detail.content"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
        </SubSection>
    </LayoutSub>
</template>
<script>
import { getProductDetail } from '@/api';
import RedLineButton from '@/components/RedLineButton.vue';
import SubSection from '@/components/SubSection.vue';
import SubTitle3 from '@/components/SubTitle3.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';
import defaultImagePath from '@/assets/no_image.png';

import { Swiper } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import {Navigation} from 'swiper/modules'
Swiper.use((Navigation))

export default {
    components: {
        LayoutSub,
        SubSection,
        RedLineButton,
        SubTitle3,
    },
    data() {
        return {
            data: {
                idx: 10,
                name: 'CS-124A',
                desc: '다재다능한 스위블 포스',
                src: '/pos/pos_11.png',
                filePaths: [],
                orgFilenames: [],
                thumbPath: '',
                orgThumbname: '',
            },
            activeIndex:0,
            prevIndex:0,
            prevPosition:0,
            swiper: null,
            swiepr2: null,
            defaultImagePath,
            thumbError: false,
            imageErrors: []
        };
    },
     methods: {
        onThumbnailClick(index) {
        if (this.swiper && typeof index === 'number' && !isNaN(index)) {

            const adjustedIndex = index === 0 ? 0 : index;
            
            this.swiper.slideTo(adjustedIndex);
        }
    },
    
    updateActiveThumbnail() {
        if (this.swiper) {
            const realIndex = this.swiper.realIndex;
            if (realIndex !== undefined && !isNaN(realIndex)) {
                this.prevIndex = this.activeIndex || 0;
                this.activeIndex = realIndex;

                const depthDom = document.querySelector('.thumbnail_wrapper');
                const thumbnails = depthDom.querySelectorAll('.item');
                const activeItem = thumbnails[realIndex];

                if (activeItem) {
                const targetPosition = activeItem.offsetLeft - depthDom.offsetLeft; 

                depthDom.scrollTo({
                    left: targetPosition,
                    behavior: 'smooth',
                });
            }
                
            } 
        }
    },
         setDefaultImage(event) {
            event.target.dataset.fallback = 'true';
            event.target.src = this.defaultImagePath; 
        },
        handleImageError(event, target) {
            if (target === 'thumb') {
                this.thumbError = true;
            } else {
                this.imageErrors.splice(target, 1, true);
            }
            this.setDefaultImage(event);
        },
        handleImageLoad(event, target) {
            if (event.target.dataset.fallback === 'true') return;

            if (target === 'thumb') {
                this.thumbError = false;
            } else {
                this.imageErrors.splice(target, 1, false);
            }
        },
    },
    async mounted() {
        const result = await getProductDetail(this.$route.params.id);
        this.data = { ...this.data, ...result.data };

        console.log(result)

        if (!result.data) {
            this.$router.replace('/product/pos');
        }

        this.data.thumbPath = result.data.thumbPath || '';
        this.data.orgThumbname = result.data.orgThumbname || '';
        this.thumbError = !this.data.thumbPath;

        for (let i = 1; i <= 8; i++) {
            const filePathKey = `file${i}Path`;
            const fileNameKey = `orgFilename${i}`;

            if (this.data[filePathKey]) {
                this.data.filePaths.push(this.data[filePathKey]);
                this.data.orgFilenames.push(this.data[fileNameKey]);
            }
        }

        this.imageErrors = this.data.filePaths.map((filePath) => !filePath);
    this.swiper = new Swiper(".mySwiper", {
        slidesPerView:'auto',
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        on: {
            slideChange: this.updateActiveThumbnail, // 슬라이드 변경 시 활성화된 썸네일 동기화
        },
        thumbs: {
        swiper: this.swiper,
      },
    });

    this.swiper.on('init', () => {
        this.updateActiveThumbnail();
    });
    },
};
</script>
<style lang="scss" scoped>
.content_title {
    font-size: 50px;
    font-weight: 700;
    color: #111;
    margin-bottom: 70px;
}

.swiper_section {
    display: flex;
    justify-content: space-between;
     @media screen and (max-width: 1280px) {
        gap: 50px;
     }
     @media screen and (max-width: 768px) {
        flex-direction: column;
     }

    .left_area {
        flex: 0 0 690px;
        height: 100%;
        @media screen and (max-width: 1280px)  {
            flex: 1 0 0;
        }
        @media screen and (max-width: 768px) {
            flex: none;
        }

        .swiper {
            position: relative;
            aspect-ratio: 690/642;
            width: 100%;
            height: 100%;

            .swiper-slide {
                width: 100% !important;
                display: flex;
                justify-content: center;
                align-items: center;
                box-sizing: border-box;

                &.no-image {
                    background: #fafafa;
                }

                img {
                    width: 70%;   
                    max-width: 480px;
                }
            }

            .swiper-handle {
                position: absolute;
                display: flex;
                justify-content: space-between;
                z-index: 4;
                width: 100%;
                padding: 0 30px;
                top: 50%;
                left: 0;
                transform: translateY(-50%);
                @media screen and (max-width: 768px) {
                    padding-inline: 15px;
                }

                button {
                    cursor: pointer;

                    @media screen and (max-width: 768px) {
                        width: 18px;
                    }
                }
            }
            .swiper-button-prev::after,
                    .swiper-button-next::after {
                        display: none;
                    }
        }

        .thumbnail_wrapper {
            margin-top: 15px;
            display: flex;
            align-items: center;
            gap: 10px;
            @media screen and (max-width: 1280px) {
                overflow-x: auto;
            }
            @media (min-width: 768px) and (max-width: 1280px) {
                flex-wrap: wrap;
            }

            .item {
                cursor: pointer;
                width: 65px;
                height: 65px;
                display: flex;
                justify-content: center;
                align-items: center;
                background: #fafafa;
                border: 1px solid #ddd;
                transition: opacity 0.3s ease, transform 0.3s ease;
                 @media screen and (max-width: 1280px)  {
                    flex: none;
                 }

                &:not(:first-child) img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }

                &:first-child {
                    // background: var(--orange);
                }

                &.active {
                    opacity: 1;
                    border: 1px solid var(--orange);
                }
            }
        }
    }

    .right_area {
        flex: 1 0 0;
        padding-top: 60px;
        padding-left: 110px;
        @media screen and (max-width: 1280px)  {
            padding-left: 0;
        }
        @media screen and (max-width: 768px) {
            padding-top: 0;
        }

        .infor_top {
            color: var(--orange);
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 30px;
            line-height: 1;
            @media screen and (max-width: 768px) {
                margin-bottom: 25px;;
            }
        }

        .infor_name {
            line-height: 1;
            font-size: 70px;
            font-weight: 700;
            color: #111;
            margin-bottom: 50px;
            @media screen and (max-width: 1280px)  {
                font-size: 50px;
            }
            @media screen and (max-width: 768px) {
                margin-bottom: 30px;
                font-size: 40px;
            }
        }

        .infor_desc {
            font-size: 20px;
            color: #111;
            margin-bottom: 30px;
            @media screen and (max-width: 768px) {
                margin-bottom: 15px;
                font-size: 18px;
            }
        }

        ul {
            margin-bottom: 70px;
            @media screen and (max-width: 768px) {
                margin-bottom: 0;
            }

            li {
                list-style: none;
                font-size: 18px;
                color: #111;
                display: flex;
                align-items: center;
                line-height: 37px;
                @media screen and (max-width: 768px) {
                    font-size: 16px;
                    line-height: 1.5;

                    + li {
                        margin-top: 10px;
                    }
                }

                &::before {
                    content: '';
                    display: inline-block;
                    width: 4px;
                    height: 4px;
                    background: #ccc;
                    margin-right: 5px;
                    @media screen and (max-width: 768px) {
                        width: 4px;height: 4px;margin-right: 5px;
                    }
                }
            }
        }

        .button_wrap {
            display: flex;
            gap: 20px;
            @media screen and (max-width: 1280px)  {
                flex-direction: column;
            }
            @media screen and (max-width: 768px) {
                margin-top: 20px;
            }
        }
    }
}

section.content {
    position: relative;
    margin-top: 120px;
}

section.table {
    div {
        +div {
            margin-top: 60px;
        }

        table {
            border-top: 2px solid #111;
            border-collapse: collapse;
            width: 100%;

            @media screen and (max-width: 1024px){
                max-width: 600px;
            }

            thead {
                tr {
                    text-align: center;
                    background: #fafafa;
                    font-size: 22px;
                    color: #111;
                }
            }

            tr {
                border-bottom: 1px solid #e5e5e5;
                height: 90px;

                @media screen and (max-width: 1024px){
                    height: auto;
                }

                th {
                    border-right: 1px solid #e5e5e5;
                    font-weight: 600;
                    width: 440px;

                    @media screen and (max-width: 1024px){
                        width: 30% !important;
                    }
                }

                td {
                    padding-left: 40px;
                    font-weight: 400;
                    color: #666;
                }

                th, td {
                    @media screen and (max-width: 1024px){
                        font-size: 16px;
                        padding: 10px;
                        width: auto;
                    }

                    @media screen and (max-width: 768px) {
                        font-size: 14px;
                    }
                }
            }
        }
    }
}
</style>
